/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Logout: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="logout" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M680 1076.6666666666667H283.3333333333333V283.3333333333335H680V170H170V1076.6666666666667C170 1107.8333333333333 181.1066666666667 1134.4666666666667 203.32 1156.68A109.0833333333333 109.0833333333333 0 0 0 283.3333333333333 1190H680V1076.6666666666667zM1190 680L906.6666666666666 396.6666666666668L828.75 478.8333333333334L973.25 623.3333333333334H510V736.6666666666667H973.25L828.75 881.1666666666667L906.6666666666666 963.3333333333334L1190 680z" : "M544 861.3333333333333H226.6666666666667V226.6666666666667H544V136H136V861.3333333333333C136 886.2666666666667 144.8853333333333 907.5733333333332 162.656 925.344A87.2666666666667 87.2666666666667 0 0 0 226.6666666666667 952H544V861.3333333333333zM952 544L725.3333333333334 317.3333333333333L663 383.0666666666666L778.6 498.6666666666666H408V589.3333333333333H778.6L663 704.9333333333334L725.3333333333334 770.6666666666666L952 544z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Logout.displayName = `Blueprint5.Icon.Logout`;
export default Logout;
